import moment from "moment";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link, useNavigate } from "react-router-dom";
import { USER_LOG_ENTRY_TYPES } from "../../../../api/constants";
import { ConfirmActionButton } from "../../../button/ConfirmActionButton";
import { KeyValueList } from "../../../list/KeyValueList";
import { Badge } from "../../../misc/Badge";
import { ContentGroup, Popup, PopupContent, PopupTitle } from "../../../notify/Popup";
import { Text } from "../../../typography/Text";
import { DurationCounter } from "../../DurationCounter";
import { ItemListForTrips } from "../../../../reusable/ItemList/ItemListForTrips";

const msgKey = "timeLogEntry";

export const TimeLogEntry = ({ busyDeleting, entry, onClose, onDelete }) => {
    const navigate = useNavigate();

    return (
        <Popup onClose={onClose}>
            <PopupTitle
                icon="clock"
                subtitle={
                    <>
                        {moment(entry.startTime).format("LLL")} -{" "}
                        {entry.endTime ? (
                            moment(entry.endTime).format("LLL")
                        ) : (
                            <FormattedMessage id={`${msgKey}.ongoing`} />
                        )}
                    </>
                }
            >
                <FormattedMessage id={USER_LOG_ENTRY_TYPES[entry.type].label} />
            </PopupTitle>
            <PopupContent padding="none">
                <ContentGroup>
                    <KeyValueList>
                        <KeyValueList.Item label={<FormattedMessage id={`${msgKey}.type`} />}>
                            <Badge fill customColor={USER_LOG_ENTRY_TYPES[entry.type].color}>
                                <FormattedMessage id={USER_LOG_ENTRY_TYPES[entry.type].label} />
                            </Badge>
                        </KeyValueList.Item>
                        <KeyValueList.Item label={<FormattedMessage id={`${msgKey}.duration`} />}>
                            <DurationCounter ranges={[{ from: entry.startTime, to: entry.endTime }]} />
                        </KeyValueList.Item>
                        <KeyValueList.Item label={<FormattedMessage id={`${msgKey}.startTime`} />}>
                            {moment(entry.startTime).format("LLL")}
                        </KeyValueList.Item>
                        <KeyValueList.Item label={<FormattedMessage id={`${msgKey}.endTime`} />}>
                            {entry.endTime ? (
                                moment(entry.endTime).format("LLL")
                            ) : (
                                <FormattedMessage id={`${msgKey}.ongoing`} />
                            )}
                        </KeyValueList.Item>
                        {entry.vessel && (
                            <KeyValueList.Item label={<FormattedMessage id={`${msgKey}.vessel`} />}>
                                <Link to={`/vessels/${entry.vessel.id}`}>{entry.vessel.name}</Link>
                            </KeyValueList.Item>
                        )}
                        <KeyValueList.Item label={<FormattedMessage id={`${msgKey}.remarks`} />}>
                            {entry.remarks || (
                                <Text color="base40">
                                    <FormattedMessage id={`${msgKey}.noRemarks`} />
                                </Text>
                            )}
                        </KeyValueList.Item>
                    </KeyValueList>
                </ContentGroup>
                {entry.trip ? (
                    <ContentGroup title={<FormattedMessage id={`${msgKey}.trip`} />}>
                        <ItemListForTrips
                            list={[entry.trip]}
                            onItemClick={(trip) => navigate(`/vessels/${entry.vessel.id}/trips/${trip.id}`)}
                        />
                    </ContentGroup>
                ) : null}
                {!!onDelete && (
                    <ContentGroup>
                        <ConfirmActionButton
                            fill
                            busy={busyDeleting}
                            label={<FormattedMessage id={`${msgKey}.deleteEntry`} />}
                            question={<FormattedMessage id={`${msgKey}.deleteQuestion`} />}
                            onConfirm={() => onDelete(entry)}
                        />
                    </ContentGroup>
                )}
            </PopupContent>
        </Popup>
    );
};
